// extracted by mini-css-extract-plugin
export default {"cls1":"vEd4SZw_yAQGw4wPDip7","cls2":"Qv5bHRg3SaO9hnZZHv30 vEd4SZw_yAQGw4wPDip7"};